import { getElementConstantHeight } from '@utils/elements';
import { halfPageManagerUpdateRepeaterHeights as updateRepeaterHeights } from './halfPageManagerUpdateRepeaterHeights';
import { halfPageManagerInsertRepeaters as insertRepeaters } from './halfPageManagerInsertRepeaters';
import { halfPageManagerState as state } from './halfPageManagerState';
import * as els from './halfPageManagerElements';
import * as consts from './halfPageManagerConstants';

// Inicializace repeater bannerů dle výšek bloků
export const halfPageManagerInitRepeaters = (): void => {
  if (els.topAside) {
    const topContentHeight: number = (els.topContent as HTMLElement).offsetHeight;

    if (els.bottomAside) {
      // Dva aside bloky s reklamami na stránce
      // Spodní obsahuje reklamy pozice 313 opakující se dle výšky spodního bloku
      state.setContentElement(els.bottomContent as HTMLElement);
      state.setElementToInsertRepeaterInto(els.bottomAside);
    } else {
      // Jeden aside blok s reklamami na stránce, obsahuje navíc pozici 311
      // Pokud je to možné, vložíme reklamy pozice 313 opakující se dle výšky bloku
      state.setContentElement(els.topContent as HTMLElement);
      state.setElementToInsertRepeaterInto(els.topAside);
    }

    if (
      // Pokud existuje spodní aside blok, zkusíme vložení vždy
      // Jinak pouze pokud je v postranním bloku místo, pozice 311 již může sama o sobě stačit
      (els.bottomAside || topContentHeight > consts.HALFPAGE_WRAPPER_MAX_HEIGHT) &&
      state.getContentElement()
    ) {
      getElementConstantHeight({
        el: state.getContentElement() as HTMLElement,
        intervalDelay: 50,
      }).then(
        (insertedContentHeight: number) => {
          const topAdHeightInRepeaterBlock: number =
            state.getContentElement() === els.topContent
              ? consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
              : 0;
          const availableHeightForRepeaterCalc: number =
            insertedContentHeight - consts.HALFPAGE_AD_HEIGHT - topAdHeightInRepeaterBlock;

          // Uložíme si výšku hlavního obsahu
          state.setContentHeight(insertedContentHeight);

          // Spočítáme si počet repeaterů ke vložení bez případného miniplayeru a horní reklamy
          state.setRepeaterBannerInsertCount(
            Math.floor(availableHeightForRepeaterCalc / consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT) + 1
          );

          // Spočítáme výšku posledního banneru a nastavíme ji pro scrollování do konce obsahu
          state.setLastBannerHeight(
            state.getContentHeight() -
              (state.getElementToInsertRepeaterInto() === els.topAside
                ? consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
                : 0) -
              (state.getRepeaterBannerInsertCount() - 1) * consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
          );

          // Vložíme repeatery a nastavíme jim výšky
          insertRepeaters();
          updateRepeaterHeights();
        },
        () => {}
      );
    }
  }
};
